import React, { useState, useEffect } from "react";
import { Typography, Table, TableFooter, DateFilterModal } from "components";
import makeRequest from "services/makeRequest";
import { routes } from "routes/apiRoutes";
import { genderOptions } from "utils/constants";
import { formatUrlQuery, formatFilterPayload } from "utils/helper";
import { capitalizeFirstLetter, formatDateTime } from "utils/helper";

const AgentManagement = ({ aggregatorId }) => {
  const [isDateModalOpen, setIsDateModalOpen] = useState(false);

  const initialFilterState = {
    number: 1,
    createdDateFrom: "",
    createdDateTo: "",
    status: "",
    username: "",
    size: 10,
    parentId: aggregatorId,
    userType: "AGENT_USER",
    sorted: true,
  };

  const [filterState, setFilterState] = useState(initialFilterState);

  const {
    size,
    number,
    orderBy,
    createdDateFrom,
    createdDateTo,
    sorted,
    userType,
    status,
  } = filterState;

  const [data, setData] = useState({
    users: null,
    loading: false,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "size") {
      filterState.number = 1;
    }
    setFilterState({ ...filterState, [name]: value });
  };

  const getusersData = (queryParams) =>
    makeRequest("get", routes.getAgentPersonalDetails(queryParams));

  const loadUsers = async (
    queryParams = formatUrlQuery(formatFilterPayload(filterState))
  ) => {
    setData({ ...data, loading: true });
    try {
      const res = await getusersData(queryParams);
      setData((prev) => ({
        ...prev,
        users: res.data.data,
        loading: false,
      }));
    } catch (err) {
      setData((prev) => ({
        ...prev,
        loading: false,
      }));
      console.log(err);
    }
  };

  const agentColumns = [
    {
      Header: "S/N",
      Cell: (row) => {
        let sn = Number(row.row.id) + 1;
        return sn.toString().length === 1 ? "0" + sn : sn;
      },
    },
    {
      Header: "Name",
      Cell: ({ row }) =>
        capitalizeFirstLetter(row.original.firstName) +
        " " +
        capitalizeFirstLetter(row.original.lastName),
    },
    {
      Header: "Gender",
      accessor: "gender",
      Cell: ({ value }) =>
        genderOptions.find((gender) => gender.value === value)?.label || "",
    },
    {
      Header: "Agent Code",
      accessor: "agentDetails",
      Cell: ({ value }) => value.agentCode || "Nil",
      customWidth: "7rem",
    },
    {
      Header: "Username",
      accessor: "username",
    },
    {
      Header: "Phone Number",
      Cell: ({ row }) => row.original.phoneNumber || "",
    },
    {
      Header: "Date Registered",
      accessor: "createdDate",
      Cell: ({ row }) => formatDateTime(row.original.agentDetails.createdDate),
      customWidth: "8rem",
    },
  ];

  useEffect(() => {
    loadUsers();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [number, size, orderBy, userType, sorted, status]);

  return (
    <div style={{ margin: "7rem 0 1.5rem" }}>
      <Typography state="primary" className="mb-3" variant="subtitle3">
        Agents Attached
      </Typography>
      <Table
        columns={agentColumns}
        data={data?.users?.content || []}
        loading={data.loading}
      />
      {data?.users?.content?.length ? (
        <TableFooter
          pageSize={filterState.size}
          handleChange={handleChange}
          availableDataLength={data?.users?.content?.length}
          totalDataLength={data.users.totalElements}
          handlePageClick={(pageNo) =>
            setFilterState({ ...filterState, number: pageNo })
          }
        />
      ) : (
        ""
      )}
      <DateFilterModal
        openDateModal={isDateModalOpen}
        setOpenDateModal={() => setIsDateModalOpen(!isDateModalOpen)}
        handleChange={handleChange}
        startDate={createdDateFrom}
        endDate={createdDateTo}
        startDateName={"createdDateFrom"}
        endDateName={"createdDateTo"}
        onButtonClick={() => {
          setIsDateModalOpen(false);
          loadUsers();
        }}
      />
    </div>
  );
};

export default AgentManagement;
